import { UAContext } from '@quentin-sommer/react-useragent';
import React, { useContext } from 'react';
import { EmergencyContainer } from '~components/base-form';
import { IEmergencyProps } from '~components/base-form/emergency-container';
import { BaseModal } from '~components/modal';

interface IGuarantorModalProps {
  emergency: IEmergencyProps | undefined | null;
  isShow: boolean;
  onClose: () => void;
  onSuccess: (value: any) => void;
  modalTitle: string;
  loading?: boolean;
  isEdit?: boolean;
}

const GuarantorModal: React.FC<IGuarantorModalProps> = ({
  emergency,
  isShow,
  onClose,
  onSuccess,
  modalTitle,
  loading,
  isEdit,
}) => {
  const uaResults = useContext(UAContext).uaResults as UAResults;
  const isMobile = uaResults.mobile;
  return (
    <>
      <BaseModal
        mobileHeightType="full"
        title={modalTitle}
        isOpen={isShow}
        onClose={() => onClose()}
        wrapperStyle={{ width: isMobile ? '100%' : 856 }}
      >
        <EmergencyContainer
          emergency={emergency}
          loading={loading}
          isEdit={isEdit}
          onSuccess={(values: any) => {
            if (onSuccess) onSuccess(values);
          }}
        />
      </BaseModal>
    </>
  );
};

export default GuarantorModal;
